import React from "react";

const Title = () => {
  return <>Vouchers Machine</>;
};

export default Title;
